module.exports = __webpack_public_path__ + "static/media/aus-flag.07724cf1.png";